import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UserMembershipDto } from '../../../models/user-membership/dto/user-membership.dto';
import { GET_USER_MEMBERSHIPS_QUERY_KEY } from './useGetUserMemberships';

export const useDeleteUserMembership = (membershipId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['deleteUserMembership', membershipId],
        mutationFn: async (body: UserMembershipDto) => {
            const response = await apiClient.fetchApi<{}, {}>({ method: 'DELETE', endpoint: `user-memberships/${membershipId}`, body });
            return response
        },
        onSuccess: (data: {}, variables: UserMembershipDto) => {
            queryClient.setQueryData<UserMembershipDto[]>(GET_USER_MEMBERSHIPS_QUERY_KEY(variables.userId), (previousData) => {
                return [...(previousData || []).filter(item => item.id !== membershipId)];
            });
        }
    });
};